var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('empty',{attrs:{"state":"5","text":"页面找不到"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }